module.exports = __webpack_public_path__ + "img/works_installations.59efd096.jpg";